import { createStore } from 'vuex';
import { getUserInfo, logout } from '@/apis/user';
import { unfinishedTask, currentPause } from '@/apis/index';
import { hasPermissions } from '@/utils/index';

export default createStore({
  state: {
    cachePages: [],
    userInfo: sessionStorage.getItem('userInfo') ? JSON.parse(sessionStorage.getItem('userInfo')) : {},
    token: sessionStorage.getItem('token') || '',
    bundleInfo: sessionStorage.getItem('bundleInfo') ? JSON.parse(sessionStorage.getItem('bundleInfo')) : null, // 当前扫菲的信息
    unFinishTaskInfo: null, // 当前正在进行的工序任务
    permissions: sessionStorage.getItem('permissions') ? JSON.parse(sessionStorage.getItem('permissions')) : [], // 权限
    bundleSwitch: sessionStorage.getItem('bundleSwitch') ? JSON.parse(sessionStorage.getItem('bundleSwitch')) : [], // 开关预设值
    currentStopInfo: null, // 当前用户是否有暂停信息
  },
  getters: {
    // 是否是管理员
    isAdmin(state) {
      return state.userInfo?.userInfo?.isDeptAdmin;
    },
    // 绩效相关字段
    // 耗时总计
    hasTotalTimeConsuming() {
      return hasPermissions(['make:salary:salaryReview:performanceRelated:totalTimeConsuming']);
    },
    // 实际单件耗时
    hasUnitTimeConsuming() {
      return hasPermissions(['make:salary:salaryReview:performanceRelated:unitTimeConsuming']);
    },
    // 耗时状态
    hasTimeConsumingStatus() {
      return hasPermissions(['make:salary:salaryReview:performanceRelated:timeConsumingStatus']);
    },
    // 单件工价（不含基础工资）
    hasUnitPrice() {
      return hasPermissions(['make:salary:salaryReview:performanceRelated:unitPrice']);
    },
    // 综合单价工价（含基础工资）
    hasComprehensiveUnitPrice() {
      return hasPermissions(['make:salary:salaryReview:performanceRelated:comprehensiveUnitPrice']);
    },
    // 不良率
    hasDefectRate() {
      return hasPermissions(['make:salary:salaryReview:performanceRelated:defectRate']);
    },
    // 标准不良率差值
    hasStandardDefectRateSub() {
      return hasPermissions(['make:salary:salaryReview:performanceRelated:standardDefectRateSub']);
    },
    // 超出标准日工资比例
    hasExceedStandardDailyWageRatio() {
      return hasPermissions(['make:salary:salaryReview:performanceRelated:exceedStandardDailyWageRatio']);
    },
    // 是否为有绩效版本
    hasPerformanceVersion(state, getters) {
      return (
        getters.hasTotalTimeConsuming ||
        getters.hasUnitTimeConsuming ||
        getters.hasTimeConsumingStatus ||
        getters.hasUnitPrice ||
        getters.hasComprehensiveUnitPrice ||
        getters.hasDefectRate ||
        getters.hasStandardDefectRateSub ||
        getters.hasExceedStandardDailyWageRatio
      );
    },
  },
  mutations: {
    // 设置用户信息
    setUserInfo(state, userInfo) {
      sessionStorage.setItem('userInfo', JSON.stringify(userInfo));
      sessionStorage.setItem('permissions', JSON.stringify(userInfo.resourceScopes));
      sessionStorage.setItem('bundleSwitch', JSON.stringify(Object.values(userInfo.bundleSwitch || {})));
      state.userInfo = userInfo;
      state.permissions = userInfo.resourceScopes || [];
      state.bundleSwitch = Object.values(userInfo.bundleSwitch || {});
    },
    // 设置token
    setToken(state, token) {
      sessionStorage.setItem('token', token);
      state.token = token;
    },
    // 设置菲信息
    setBundleInfo(state, bundleInfo) {
      sessionStorage.setItem('bundleInfo', bundleInfo);
      state.bundleInfo = bundleInfo ? JSON.parse(bundleInfo) : null;
    },
    // 设置当前正在做的工序任务
    setUnFinishTaskInfo(state, unFinishTaskInfo) {
      state.unFinishTaskInfo = unFinishTaskInfo;
    },
    setCurrentStopInfo(state, currentStopInfo) {
      state.currentStopInfo = currentStopInfo;
    },
    // 添加缓存页面
    addCachePage: (state, pageName) => {
      if (!state.cachePages.includes(pageName)) {
        state.cachePages.push(pageName);
      }
    },
    // 删除缓存页面
    deleteCachePage: (state, pageName) => {
      if (state.cachePages.includes(pageName)) {
        state.cachePages = state.cachePages.filter((item) => item !== pageName);
      }
    },
  },
  actions: {
    // 获取用户信息
    getUserInfo({ commit }) {
      return new Promise((resolve, reject) => {
        getUserInfo()
          .then((res) => {
            commit('setUserInfo', res.data);
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // 登出
    LogOut({ commit }) {
      return new Promise((resolve, reject) => {
        logout()
          .then(() => {
            commit('setUserInfo', {});
            commit('setToken', '');
            sessionStorage.clear();
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // 获取当前正在做的工序任务
    getUnFinishTaskInfo({ commit }) {
      return new Promise((resolve, reject) => {
        unfinishedTask()
          .then((res) => {
            commit('setUnFinishTaskInfo', res.data || null);
            resolve();
          })
          .catch((error) => {
            console.log('error', error);
            reject(error);
          });
      });
    },
    getCurrentPause({ commit }) {
      return new Promise((resolve, reject) => {
        currentPause()
          .then((res) => {
            commit('setCurrentStopInfo', res.data || null);
            resolve();
          })
          .catch((error) => {
            console.log('error', error);
            reject(error);
          });
      });
    },
  },
  modules: {},
});
